import './styles/stripe.css';
import MicroModal from 'micromodal';

/* 

For payment with Stripe

*/
export const initStripePayment = async (
    paymentDetails,
    callbackFunc
) => {
    let stripe = Stripe(paymentDetails.public_key);
    let elements = stripe.elements();

    const currency = paymentDetails.amount.currency.toUpperCase();
    const amount = paymentDetails.amount.amount;
    const name = paymentDetails.billing_address.name;
    const phone = paymentDetails.billing_address.phone;
    const client_secret = paymentDetails.client_secret;
    let billingDetails = paymentDetails.billing_address || {};

    const setOutcome = (result) => {
        var waitElement = document.querySelector('.wait');
        var errorElement = document.querySelector('.error');
        waitElement.classList.remove('visible');
        errorElement.classList.remove('visible');

        if (result.inProgress) {
            waitElement.textContent = 'Please wait..';
            waitElement.classList.add('visible');
        } else if (result.error) {
            errorElement.textContent = result.error.message;
            errorElement.classList.add('visible');
        }
    }

    MicroModal.init();

    const existingModal = document.getElementById('stripe-payment-modal');
    if (existingModal) {
        existingModal.remove();
    }

    const modal = document.createElement('div');
    modal.innerHTML = `
        <div class="stripe-payment-modal micromodal-slide" id="stripe-payment-modal" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
            <header class="modal__header">
            <h2 class="modal__title" id="modal-1-title">
                Powered by Stripe
            </h2>
            </header>
            <main class="modal__content" id="modal-1-content">
            <form class="stripe-payment-form">
            <div class="group">
            <label>
                <span>Name</span>
                <input name="cardholder-name" value="${name || ''}" class="field stripe-name-input" placeholder="Jane Doe" />
            </label>
            <label>
                <span>Phone</span>
                <input type="number" class="field stripe-phone-input" value="${phone || ''}" placeholder="(123) 456-7890" type="tel" />
            </label>
            </div>
            <div class="group">
            <label>
                <span>Card</span>
                <div id="card-element" class="field"></div>
            </label>
            </div>
            <button class="stripe-pay-btn" type="submit">Pay ${amount} ${currency}</button>
            <div class="outcome">
            <div class="error"></div>
            <div class="wait">
            </div>
            </div>
        </form>
            </main>
        </div>
        </div>
    </div>`;

    document.body.appendChild(modal);

    MicroModal.show('stripe-payment-modal', {
        onClose: () => {
            callbackFunc({ status: 'closed' });
        }
    });

    let card = elements.create('card', {
        hidePostalCode: true,
        style: {
            base: {
                iconColor: '#F99A52',
                color: '#32315E',
                lineHeight: '48px',
                fontWeight: 400,
                fontFamily: '"Open Sans", "Helvetica Neue", "Helvetica", sans-serif',
                fontSize: '15px',

                '::placeholder': {
                    color: '#CFD7DF',
                }
            },
        }
    });

    card.on('change', (event) => {
        setOutcome(event);
    });

    card.mount("#card-element");

    document.querySelector('.stripe-payment-form').addEventListener('submit', (e) => {
        e.preventDefault();
        document.querySelector('.stripe-pay-btn').disabled = true;
        setOutcome({ inProgress: true });

        const nameInput = document.querySelector('.stripe-name-input').value;
        const phoneInput = document.querySelector('.stripe-phone-input').value;
        if (!nameInput || (/\d/.test(nameInput))) {
            setOutcome({ error: { message: 'Please enter a valid Name' } });
            document.querySelector('.stripe-pay-btn').disabled = false;
            return;
        }

        if (!phoneInput || (phoneInput.length > 10 || (phoneInput.length < 10 && phoneInput.length > 0))) {
            setOutcome({ error: { message: 'Please enter a valid Phone number' } });
            document.querySelector('.stripe-pay-btn').disabled = false;
            return;
        }

        stripe.confirmCardPayment(client_secret, {
            payment_method: {
                type: 'card',
                card: card,
                billing_details: {
                    name: billingDetails.name || '',
                    email: billingDetails.email || '',
                    address: {
                        city: billingDetails.city || '',
                        line1: billingDetails.street1 || '',
                        state: billingDetails.state || '',
                        postal_code: billingDetails.postalCode || '',
                    },
                }
            }
        }).then((result) => {
            if (result.error) {
                setOutcome(result);
                document.querySelector('.stripe-pay-btn').disabled = false;
            } else {
                if (result.paymentIntent.status === 'succeeded') {
                    callbackFunc({ status: 'success', message: 'Payment Successful', transactionId: paymentDetails.id });
                } else {
                    callbackFunc({ status: 'failed', message: 'Payment Failed', transactionId: paymentDetails.id });
                }

                setOutcome({ inProgress: false });
                document.querySelector('.stripe-pay-btn').disabled = false;

                MicroModal.close('stripe-payment-modal');
            }
        });
    });
};